.skip-to-content > a {
  position: absolute;
  color: #fff;
  background-color: #212121;
  padding: 1rem;
  border-radius: 0 0 0.5rem;
  transform: translateY(-120%);
  transition: transform 0.3s;
  z-index: 2;

  &:focus {
    transform: translateY(0);
    color: #fff !important;
    outline-offset: 2px;
  }
}
